module.exports = __webpack_public_path__ + "img/riders.c4509f5b.svg";